import { Field, FieldRenderProps } from '@progress/kendo-react-form';
import React, { FunctionComponent, useEffect, useMemo } from 'react'
import StaffList from '../../User/ListControls/StaffList';
import { IAction, IActionUI } from '../../../types/Action/IAction';
import RoleList from '../../Ticket/ListControls/RoleList';
import { Api } from '../../../redux/api/BaseApi';
import Time from '../../Common/Time';
import { Checkbox } from '@progress/kendo-react-inputs';
import { UserApi } from '../../../redux/api/UserApi';
import ActionDate from '../ActionDate';
import QuickNotes from '../../Ticket/QuickNotes/QuickNotesList';
import { TicketApi } from '../../../redux/api/TicketApi';
import { IQuickNoteCategory } from '../../../types/Ticket/IQuickNotes';
import { useReduxDispatch, useReduxSelector } from '../../../redux/hooks';
import Stopwatch from '../../Ticket/FormControls/Stopwatch';
import { IStopwatch } from '../../../types/Ticket/IStopwatch';
import { Error } from "@progress/kendo-react-labels";
import * as ActionSlice from '../../../slices/ActionSlice';
import { PRIVATE_ACTION_ID } from '../../../slices/ActionSlice';
import { ActionNoteTextEditor } from './ActionNoteTextEditor';

const ActionNote: FunctionComponent<FieldRenderProps> = formRenderProps => {
    const {
        companyId,
        statusId,
    } = formRenderProps;
    const dispatch = useReduxDispatch();
    const { action, settings } = useReduxSelector(state => state.actionDetails);
    const { data: userProfile } = Api.useGetUserProfileQuery();
    const { data: status } = TicketApi.useGetStatusQuery(statusId, { skip: !statusId || userProfile?.Features?.External_Interface })
    const addTimeSettings = useMemo(() => { return { canAddTime: (!status || status?.Allow_Add_Time), warning: `No time can be added because it is disabled for this ${userProfile?.Phrases.CallPhrase} Status (${status?.Call_Status})` } }, [status]);
    const { data: author } = UserApi.useGetUserByIdQuery(action?.Staff_Id || userProfile?.Id)
    //const [actionNote, setActionNote] = React.useState<IAction>(action);    
    const [quickNoteId, setQuickNoteId] = React.useState(action?.Quick_Note_Id);
    const { data: quickNote } = TicketApi.useGetQuickNoteAsActionQuery({ id: action?.Quick_Note_Id, ticketId: 0 }, { skip: !action?.Quick_Note_Id })
    const authorChanged = (e: { value: any }) => { fireUpdate({ ...action, Role_Id: 0, Staff_Id: e.value.length > 0 ? e.value[0] : null }) }
    const privateChanged = (e: { value: any }) => {
        let actionTypeId = e.value ? PRIVATE_ACTION_ID : undefined;
        dispatch(ActionSlice.SetUISettings({ ...settings, Bill_Time_Enabled: actionTypeId !== PRIVATE_ACTION_ID, NonBill_Time_Enabled: actionTypeId !== PRIVATE_ACTION_ID } as IActionUI));
        fireUpdate({ ...action, Action_Type_Id: actionTypeId, Billable_Time: e.value ? 0 : action.Billable_Time, Non_Billable_Time: e.value ? 0 : action.Non_Billable_Time })
    }
    const nonBillChanged = (e: { value: any }) => { fireUpdate({ ...action, Non_Billable_Time: e.value }) }
    const billChanged = (e: { value: any }) => {
        console.log('billChanged', e.value)
        fireUpdate({ ...action, Billable_Time: e.value })
    }

    const roleChanged = (e: { value: any }) => { fireUpdate({ ...action, Role_Id: e.value.Role_id }) }
    // const noteChanged = (e: { value: any }) => { fireUpdate({ ...action, HTML_Notes: e.value === '<p></p>' ? '' : e.value }) }
    const quickNoteChanged = (e: { value: IQuickNoteCategory }) => {
        if (!e.value || !action?.HTML_Notes || window.confirm(`Changing the Quick Note will REPLACE all text in the ${userProfile.Phrases.Action} Note. Are you sure you want to continue?`)) {
            fireUpdate({ ...action, Quick_Note_Id: e.value?.Id })
            //console.log('fireUpdate', e);
            //onQuickNoteChanged(e.value)
        }
    }
    const pinChanged = (e: { value: any }) => { fireUpdate({ ...action, Pinned: e.value }) }
    const skipChanged = (e: { value: any }) => { fireUpdate({ ...action, SkipActionEmail: e.value }) }
    const dateChanged = (e: { value: any }) => {
        console.log('dateChanged', e.value)
        fireUpdate({ ...action, Action_Dt: e.value?.toISOString() })
    }
    const fireUpdate = React.useCallback((action: IAction) => {
        //console.log('fireUpdate')
        //setActionNote(action);
        //formRenderProps.onChange({ value: action });
        dispatch(ActionSlice.SetAction(action));
    }, [dispatch]);

    const stopwatchTicked = (e: IStopwatch) => {
        if (action) {
            //console.log('stopwatchTicked', e.action?.HTML_Notes?.length, action?.HTML_Notes?.length, action?.HTML_Notes?.length)

            var delta = Math.abs(new Date().getTime() - new Date(e.Start_Dt + 'Z').getTime()) / 1000;
            var minutes = Math.floor(delta / 60);
            var time = { Billable_Time: action.Billable_Time, Non_Billable_Time: action.Non_Billable_Time }
            if (e.Is_Bill) time.Billable_Time = minutes
            else time.Non_Billable_Time = minutes

            //fireUpdate({ ...action, ...time })
            //onBillChanged(time.Billable_Time);
            e.Is_Bill
                ? dispatch(ActionSlice.SetBill(time.Billable_Time))
                : dispatch(ActionSlice.SetNonBill(time.Non_Billable_Time))
        }
    }
    const stopwatchStarted = (e: IStopwatch) => {
        let note = action?.HTML_Notes || '';

        //new Date(e.Start_Dt)

        note += `Stopwatch started at ${new Date(e.Start_Dt).toLocaleString()} by ${userProfile.F_Name} ${userProfile.L_Name}<br/>`

        //Stopwatch started
        dispatch(ActionSlice.SetUISettings({ ...settings, Bill_Time_Enabled: e.Is_Bill ? false : settings.Bill_Time_Enabled, NonBill_Time_Enabled: e.Is_Bill ? settings.NonBill_Time_Enabled : false } as IActionUI));
        fireUpdate({ ...action, HTML_Notes: note })
    }
    const stopwatchStopped = (e: IStopwatch) => {
        if (e) {
            let note = action?.HTML_Notes || '';

            note += `Stopwatch stopped at ${new Date(e.Stop_Dt).toLocaleString()} by ${userProfile.F_Name} ${userProfile.L_Name}<br/>`

            //Stopwatch started
            dispatch(ActionSlice.SetUISettings({ ...settings, Bill_Time_Enabled: e.Is_Bill ? true : settings.Bill_Time_Enabled, NonBill_Time_Enabled: e.Is_Bill ? settings.NonBill_Time_Enabled : true } as IActionUI));
            fireUpdate({ ...action, HTML_Notes: note })
        }
    }

    useEffect(() => {
        //console.log('sActionNote.tsx: Status useEffect', status)
        if (status && !status.Allow_Add_Time && (action.Billable_Time > 0 || action.Non_Billable_Time > 0)) {
            //Remove time if isallowed by the Call status
            fireUpdate({ ...action, Billable_Time: 0, Non_Billable_Time: 0 })
        }
    }, [status, fireUpdate, action])

    // useEffect(() => {
    //     console.log('ActionNote.tsx: action useEffect', action?.HTML_Notes?.length)
    //     setActionNote(action);
    // }, [action])


    useEffect(() => {
        //console.log('quickNote useEffect', quickNote)
        if (quickNote && quickNoteId !== action.Quick_Note_Id) {
            let newAction = { ...action }

            //Bill / Non Bill
            if (quickNote.Billable_Time) newAction.Billable_Time = quickNote.Billable_Time
            if (quickNote.Non_Billable_Time) newAction.Non_Billable_Time = quickNote.Non_Billable_Time

            //Private
            newAction.Action_Type_Id = quickNote.Is_Private_Action ? PRIVATE_ACTION_ID : undefined;

            //console.log('Set Action note', quickNote.Action_Notes, quickNote.Action_Notes.indexOf('\r\n'), quickNote.Action_Notes.indexOf('\n'));
            //Set Action note
            fireUpdate({ ...newAction, HTML_Notes: quickNote.HTML_Notes || quickNote.Action_Notes?.replaceAll(/(?:\r\n|\r|\n)/g, '<br>') })
            dispatch(ActionSlice.SetUISettings({ ...settings, Bill_Time_Enabled: newAction.Action_Type_Id !== PRIVATE_ACTION_ID, NonBill_Time_Enabled: newAction.Action_Type_Id !== PRIVATE_ACTION_ID } as IActionUI));

            setQuickNoteId(quickNote?.Quick_Note_Id)
        }
    }, [quickNote])

    const internalUser = !userProfile?.Features.External_Interface;

    return (
        <>
            <div className={`inline-block w-full align-top ${internalUser && 'lg:w-4/5'}`}>
                {internalUser && <div id="collapseActionheader" className="accordion-collapse show" aria-labelledby="headingOne" data-bs-parent="#collapseActionheader">
                    <div className="accordion-body">
                        <div className=' '>
                            {userProfile?.Features?.Show_Author &&
                                <div className='inline-block w-full sm:w-1/4 sm:pr-3  align-top'>
                                    <Field
                                        id={"author"}
                                        name={"author"}
                                        label={"Author"}
                                        onChange={authorChanged}
                                        values={[action?.Staff_Id || userProfile?.Id]}
                                        component={StaffList}
                                        companyId={companyId || userProfile.Company_Id}
                                        currentUserTop={true}
                                        showMe={true}
                                    />
                                </div>}
                            <div className='inline-block w-full sm:w-1/4  sm:pr-3 align-top'>
                                <Field
                                    id={"role"}
                                    name={"role"}
                                    label={userProfile ? userProfile?.Phrases.Role : '...'}
                                    onChange={roleChanged}
                                    uid={author?.UId}
                                    roleId={action?.Role_Id}
                                    component={RoleList}
                                />
                            </div>
                            {userProfile?.Features?.Quick_Notes && <div className='inline-block w-full md:1/2 sm:w-1/4 align-top bg-yellow'>
                                <Field
                                    id={"quick-notes"}
                                    name={"quick-notes"}
                                    label={"Quick notes"}
                                    component={QuickNotes}
                                    quickNoteId={action?.Quick_Note_Id}
                                    onChange={quickNoteChanged}
                                />
                            </div>}
                            {userProfile?.Features?.Set_Action_Date &&
                                <div className='inline-block w-full sm:w-1/4 sm:pl-3 align-top '>
                                    <Field
                                        id={"actionDate"}
                                        name={"actionDate"}
                                        label={"Date"}
                                        actionDate={action?.Action_Dt}
                                        onChange={dateChanged}
                                        component={ActionDate} />
                                </div>}
                        </div>
                    </div>
                </div>}
                <ActionNoteTextEditor />
            </div>
            {internalUser &&
                <div className='inline-block w-full lg:w-1/5 pl-2 bg-red1'>
                    {!addTimeSettings.canAddTime &&

                        <div className='inline-block w-full'>
                            <Error>{addTimeSettings.warning}</Error>
                        </div>
                    }
                    {addTimeSettings.canAddTime && <>
                        <div className='inline-block  lg:w-full w-1/2 '>
                            <Field
                                id={"bill"}
                                name={"bill"}
                                label={userProfile?.Features?.Non_Bill_Time ? "Bill (hrs)" : "Time (hrs)"}
                                component={Time}
                                mins={action?.Billable_Time}
                                disabled={settings && !settings?.Bill_Time_Enabled}
                                onChange={billChanged}
                            />
                            {userProfile?.Features?.Display_Stopwatch && action?.Action_Type_Id !== 7 &&
                                <Field
                                    id={"bill-stop-watch"}
                                    name={"bill-stop-watch"}
                                    component={Stopwatch}
                                    isBill={true}
                                    mins={action?.Bill_Min}
                                    action={action}
                                    onStart={stopwatchStarted}
                                    onStop={stopwatchStopped}
                                    onTick={stopwatchTicked}
                                />}
                        </div>
                        {userProfile?.Features?.Non_Bill_Time &&
                            <div className='inline-block  lg:w-full w-1/2 '>
                                <Field
                                    id={"nonbill"}
                                    name={"nonbill"}
                                    label={"Non-Bill (hrs)"}
                                    component={Time}
                                    disabled={settings && !settings.NonBill_Time_Enabled}
                                    mins={action?.Non_Billable_Time}
                                    onChange={nonBillChanged}
                                />
                                {userProfile?.Features?.Display_Stopwatch && action?.Action_Type_Id !== 7 &&
                                    <Field
                                        id={"nonbill-stop-watch"}
                                        name={"nonbill-stop-watch"}
                                        component={Stopwatch}
                                        mins={action?.Call_Id}
                                        onStart={stopwatchStarted}
                                        onStop={stopwatchStopped}
                                        onTick={stopwatchTicked}
                                    />}
                            </div>}
                    </>}
                    {/* Private notes feature */}
                    {userProfile?.Features?.Private_Actions &&
                        <div className='inline-block  lg:w-full w-1/2 p-2'>
                            <Field
                                id={"private"}
                                name={"private"}
                                label={"Private"}
                                component={Checkbox}
                                checked={action?.Action_Type_Id === 7}
                                onChange={privateChanged}
                            />
                        </div>}
                    {userProfile?.Features?.Pinned_Actions &&
                        <div className='inline-block  lg:w-full w-1/2 p-2'>
                            <Field
                                id={"pin"}
                                name={"pin"}
                                label={"Pin to Top"}
                                component={Checkbox}
                                checked={action?.Pinned === true}
                                onChange={pinChanged}
                            />
                            {/* action?.Pinned = {action?.Pinned === false ? 'yes' : 'no'} */}
                        </div>}
                    {userProfile?.Features?.Skip_Action_Notifications &&
                        <div className='inline-block  lg:w-full w-1/2 p-2'>
                            <Field
                                id={"skip"}
                                name={"skip"}
                                label={"Skip Notification"}
                                component={Checkbox}
                                onChange={skipChanged}
                            />
                        </div>}
                    {/* {!userProfile?.Features.External_Interface && <AINotes />} */}
                </div>}
        </>
    )
}

export default ActionNote;